// Vendor Raporlar — Funnel + Cohort + MRR Movement (basit)
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { ListPageHeader } from '../components/ui';

const fmt = (n) => new Intl.NumberFormat('tr-TR', { style:'currency', currency:'TRY', minimumFractionDigits: 0 }).format(Number(n) || 0);
const fmtN = (n) => new Intl.NumberFormat('tr-TR').format(n || 0);

export default function VendorReportsPage() {
  const [funnel, setFunnel] = useState(null);
  const [mrr, setMrr] = useState([]);
  const [cohort, setCohort] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/vendor/analytics/funnel'),
      api.get('/vendor/analytics/mrr-movement'),
      api.get('/vendor/analytics/cohort'),
    ]).then(([f, m, c]) => {
      setFunnel(f.data.data);
      setMrr(m.data.data || []);
      setCohort(c.data.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40 }}>Yükleniyor...</div>;

  // Funnel hesapla
  const funnelSteps = funnel ? [
    { label: 'Tüm Lead\'ler',       value: funnel.leads,          pct: 100 },
    { label: 'İletişime Geçilen',  value: funnel.contacted,      pct: funnel.leads > 0 ? Math.round((funnel.contacted * 100) / funnel.leads) : 0 },
    { label: 'Nitelikli',          value: funnel.qualified,      pct: funnel.leads > 0 ? Math.round((funnel.qualified * 100) / funnel.leads) : 0 },
    { label: 'Demo Verilen',       value: funnel.demo,           pct: funnel.leads > 0 ? Math.round((funnel.demo * 100) / funnel.leads) : 0 },
    { label: 'Kazanılan',          value: funnel.won,            pct: funnel.leads > 0 ? Math.round((funnel.won * 100) / funnel.leads) : 0 },
  ] : [];

  return (
    <div className="stocks-page">
      <ListPageHeader title="Raporlar & Analitik" subtitle="Funnel, MRR hareketi, cohort analizi" />

      <div style={{ padding: 18, display:'flex', flexDirection:'column', gap: 20, maxWidth: 1200 }}>
        {/* Funnel */}
        <Card title="🎯 Satış Funnel'i (tüm zamanlar)">
          {funnelSteps.length === 0 ? (
            <div style={{ color:'var(--text-tertiary)' }}>Henüz lead yok</div>
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap: 8 }}>
              {funnelSteps.map((s, i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap: 12 }}>
                  <div style={{ width: 160, fontSize:'0.85rem', fontWeight: 500 }}>{s.label}</div>
                  <div style={{ flex: 1, height: 36, background:'var(--bg-secondary)', borderRadius: 6, overflow:'hidden', position:'relative' }}>
                    <div style={{ width: s.pct + '%', height:'100%',
                                  background: `linear-gradient(90deg, var(--accent-primary) 0%, ${i === funnelSteps.length - 1 ? 'var(--success)' : 'var(--accent-primary)'} 100%)`,
                                  borderRadius: 6, transition:'width 0.4s',
                                  display:'flex', alignItems:'center', justifyContent:'flex-end', paddingRight: 10 }}>
                      <span style={{ color:'#fff', fontWeight: 700, fontSize:'0.85rem', fontVariantNumeric:'tabular-nums' }}>{s.value}</span>
                    </div>
                  </div>
                  <div style={{ width: 50, textAlign:'right', fontSize:'0.85rem', color:'var(--text-tertiary)', fontWeight: 600 }}>%{s.pct}</div>
                </div>
              ))}
            </div>
          )}
          {funnel && (
            <div style={{ display:'flex', gap: 24, marginTop: 16, paddingTop: 14, borderTop:'1px solid var(--border-secondary)', fontSize:'0.85rem' }}>
              <div><b style={{ color:'var(--accent-primary)', fontSize:'1.1rem' }}>{funnel.trial_active}</b> aktif trial</div>
              <div><b style={{ color:'var(--success)', fontSize:'1.1rem' }}>{funnel.paid_active}</b> ödeyen müşteri</div>
              <div>Trial → Paid: <b>%{funnel.trial_active + funnel.paid_active > 0
                ? Math.round((funnel.paid_active * 100) / (funnel.trial_active + funnel.paid_active)) : 0}</b></div>
            </div>
          )}
        </Card>

        {/* MRR Movement */}
        <Card title="📊 Aylık Gelir Hareketi (son 12 ay)">
          {mrr.length === 0 ? (
            <div style={{ color:'var(--text-tertiary)' }}>Henüz veri yok</div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.85rem' }}>
              <thead>
                <tr style={{ borderBottom:'1px solid var(--border-secondary)' }}>
                  <th style={{ padding:'8px 10px', textAlign:'left', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Ay</th>
                  <th style={{ padding:'8px 10px', textAlign:'right', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Faturalı Firma</th>
                  <th style={{ padding:'8px 10px', textAlign:'right', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Brüt Fatura</th>
                  <th style={{ padding:'8px 10px', textAlign:'right', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Tahsil Edilen</th>
                  <th style={{ padding:'8px 10px', textAlign:'right', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Tahsil %</th>
                </tr>
              </thead>
              <tbody>
                {mrr.map(m => (
                  <tr key={m.period} style={{ borderBottom:'1px solid var(--border-secondary)' }}>
                    <td style={{ padding:'10px', fontFamily:'monospace', fontWeight: 600 }}>{m.period}</td>
                    <td style={{ padding:'10px', textAlign:'right' }}>{m.billed_companies}</td>
                    <td style={{ padding:'10px', textAlign:'right', fontFamily:'monospace' }}>{fmt(m.gross)}</td>
                    <td style={{ padding:'10px', textAlign:'right', fontFamily:'monospace', color:'var(--success)', fontWeight: 600 }}>{fmt(m.paid)}</td>
                    <td style={{ padding:'10px', textAlign:'right', fontWeight: 600 }}>
                      {m.gross > 0 ? `%${Math.round((m.paid * 100) / m.gross)}` : '—'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Card>

        {/* Cohort */}
        <Card title="📅 Cohort Analizi (signup ayına göre tutma)">
          {cohort.length === 0 ? (
            <div style={{ color:'var(--text-tertiary)' }}>Henüz cohort verisi yok</div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.85rem' }}>
              <thead>
                <tr style={{ borderBottom:'1px solid var(--border-secondary)' }}>
                  <th style={{ padding:'8px 10px', textAlign:'left', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Signup Ay</th>
                  <th style={{ padding:'8px 10px', textAlign:'right', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Kayıt</th>
                  <th style={{ padding:'8px 10px', textAlign:'right', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Aktif</th>
                  <th style={{ padding:'8px 10px', textAlign:'right', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Churn</th>
                  <th style={{ padding:'8px 10px', textAlign:'right', color:'var(--text-tertiary)', fontWeight:600, fontSize:'0.7rem', textTransform:'uppercase' }}>Tutma %</th>
                </tr>
              </thead>
              <tbody>
                {cohort.map(c => {
                  const retention = c.signed_up > 0 ? Math.round((c.still_active * 100) / c.signed_up) : 0;
                  return (
                    <tr key={c.cohort_month} style={{ borderBottom:'1px solid var(--border-secondary)' }}>
                      <td style={{ padding:'10px', fontFamily:'monospace', fontWeight: 600 }}>{c.cohort_month}</td>
                      <td style={{ padding:'10px', textAlign:'right' }}>{c.signed_up}</td>
                      <td style={{ padding:'10px', textAlign:'right', color:'var(--success)', fontWeight: 600 }}>{c.still_active}</td>
                      <td style={{ padding:'10px', textAlign:'right', color:'var(--danger)' }}>{c.churned}</td>
                      <td style={{ padding:'10px', textAlign:'right', fontWeight: 700,
                                    color: retention >= 80 ? 'var(--success)' : retention >= 50 ? '#d97706' : 'var(--danger)' }}>
                        %{retention}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Card>
      </div>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div style={{ background:'var(--bg-secondary)', border:'1px solid var(--border-secondary)', borderRadius: 8 }}>
      <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border-secondary)', fontSize:'0.95rem', fontWeight: 600 }}>{title}</div>
      <div style={{ padding: 16 }}>{children}</div>
    </div>
  );
}
